{
  "focus.interruption.deleteAction": "Kesinti kaydını sil",
  "focus.interruption.deleteTitle": "Bu kesinti kalıcı olarak silinsin mi?",
  "focus.interruption.deleteDescription": "Bu kesintinin zamanı ve notu odak geçmişinden kaldırılacak.",
  "focus.interruption.deleteConfirm": "Kalıcı olarak sil",
  "focus.interruption.deleteError": "Kesinti silinemedi."
}
